import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import 'animate.css/animate.min.css';
import { useUpdateCheck } from 'react-update-notification';

const UpdateAlert = () => {
  const { status, reloadPage } = useUpdateCheck({
    type: 'interval',
    interval: 2 * 60 * 1000,
  });

  return status === 'available' ? (
    <div
      style={{ zIndex: '999999' }}
      className="d-flex justify-content-left position-fixed position-bottom-0 p-1 animate__animated animate__bounceInLeft vw-100"
    >
      <div
        className="d-block m-0 px-2 py-1 text-white bg-primary rounded box-shadow-2"
        style={{ maxWidth: '300px' }}
      >
        <span className="d-block mb-sm-2">
          <FormattedMessage id="new_version_checker_text" />
        </span>
        <Button.Ripple
          block
          size="md"
          color="white"
          className="w-100 mt-1 mt-sm-0"
          onClick={reloadPage}
        >
          <span className="text-nowrap">
            <FormattedMessage id="new_version_checker_refresh_button" />
          </span>
        </Button.Ripple>
      </div>
    </div>
  ) : null;
};

export default UpdateAlert;
